import type { TModernFont } from '@modern/theme/modern-theme.types';

export const typographyBaseTheme: TModernFont = {
  family: {
    mono: "ui-monospace, 'Cascadia Code', 'SF Mono', Consolas, 'JetBrains Mono', 'Courier New', monospace",
    sans: "system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', 'Noto Sans', Arial, sans-serif",
  },
  size: {
    overline: '0.5625rem',
    overlineLarge: '0.59375rem',
    micro: '0.625rem',
    captionSmall: '0.65625rem',
    caption: '0.6875rem',
    label: '0.71875rem',
    bodySmall: '0.75rem',
    bodyCompact: '0.78125rem',
    body: '0.8125rem',
    subtitle: '0.875rem',
    titleSmall: '0.9375rem',
    title: '1.03125rem',
    titleLarge: '1.1875rem',
  },
  lineHeight: {
    base: 1.5,
  },
  weight: {
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
    extraBold: 800,
  },
};
